module.exports = __webpack_public_path__ + "img/016-graphic-design-2.76a04826.svg";